





































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * Helpers
 */
import { smartDisplayMinutes, differenceInMinutesBetweenHoursMinutes, getElegantDateString } from "@/utils/date-helpers";

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * API
 */
import timeRangesAPI from "@/api/time-ranges";

/**
 * Types
 */

/**
 * Composant de fenêtre modale de création et d'édition d'une time range.
 */
@Component({ mixins: [mixinsAPI] })
export default class TimeRangeCreationEditionDialog extends Vue {
	$refs!: {
		modal: Dialog
	};

	/** Injections */
	smartDisplayMinutes = smartDisplayMinutes;
	differenceInMinutesBetweenHoursMinutes = differenceInMinutesBetweenHoursMinutes;
	getElegantDateString = getElegantDateString;


	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' })
	openInfo: any;
	@Action('openError', { namespace: 'snackbar' })
	openError: any;

	/** Propriétés */
	@Prop({ default: 'fr-FR' })
	locale!: string;

	/** Attributs */
	service: any | null = null;
	id: number | null = null;
	form: any | null = null;
	isLoading = false;

	get weekDays() {
		return [...Array(7).keys()].map((x) => ({
			value: x,
			text: this.$t(`global.week_days.${x}`)
		}));
	}

	/** Méthodes */
	async openCreate(service: any) {
		this.$refs.modal.open();
		this.id = null;
		this.service = service;
		this.form = {
			serviceID: service.id
		};
	}
	async openEdit(id: number) {
		this.$refs.modal.open();
		const initialData = await timeRangesAPI.getOne(id);
		this.id = id;
		this.service = initialData.service;
		this.form = initialData;
		this.form.serviceId = this.service.id;
	}
	close() {
		this.$refs.modal.close();
	}

	async handleSubmit() {
		this.isLoading = true;
		try {
			this.form.startHour = this.form.startTime.split(':')[0];
			this.form.startMinute = this.form.startTime.split(':')[1];
			this.form.durationInMinutes = differenceInMinutesBetweenHoursMinutes(this.form.startTime, this.form.endTime);
			if (!this.id) {
				await timeRangesAPI.create(this.form);
				this.$emit('onCreateSuccess');
			}
			else {
				await timeRangesAPI.edit(this.id, this.form);
				this.$emit('onEditSuccess');
			}
			this.isLoading = false;
			this.openInfo(this.$t('snackbar.success'));
			this.close();
		}
		catch (ex) {
			(this as any).handleAPIError(ex);
			this.isLoading = false;
		}
	}
}
